import React, {  useContext, useEffect, useLayoutEffect, useMemo, useState } from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom"
import TopBar from "./TopBar/TopBar"
import { Helmet } from 'react-helmet-async';
import logoWhiteHight from '../../image/logo/logoWhiteHight.webp'
import "./RestauScreen.css"
import { contentBlockRestau,typeDailyMenu,typeSchedule,typeSpecialDate,SpaceBlock,ReviewProps,cityWithPreposition, Menu, slugify, contentBannerResto, emptyBannerRestau } from "../../components/types/types"
import { Footer } from "../InformationScreen/BarInformationScreen"
import Loading from "../../components/loading/loading"
import { useNavigate } from "react-router-dom";

import { AppContext } from "../../context/AppContext";

import MenuPage from "./NavigationPage/MenuPage";
const RestaurantPage = React.lazy(() => import("./NavigationPage/RestaurantPage"));
const ReservationPage = React.lazy(() => import("./NavigationPage/ReservationPage"));
const ContainerFiltersResto = React.lazy(() => import("../../components/filter/containerFiltersResto/containerFiltersResto"));
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

interface RestauScreenProps {
    MenuLoad? : Menu;
    lastUpdateScheduleLoad?: Date,
    listdescLoad?: (contentBlockRestau | SpaceBlock)[],
    headerDescLoad? : [ contentBannerResto,typeSchedule,string,typeSpecialDate],
    listBannerLoad?:contentBannerResto[],
    idrestaurant?:number,
    phoneLoad?:string,
    addressLoad?:[string,string],
    styleMenuLoad?:number,
    interactMenuLoad?:boolean,
    addressHintLoad?:string
}

interface RestoMeta {
  id: number;
  name: string;
  note: number;
  type: string[];
  cuisines: string[];
  filters: string[];
  devanture: string;
  nbrReview: number;
  visibleCity: string;
  totalPrice: number;
  googlePlaceId?: string;
}
const prefetchCache = new Set<number>();

const prefetchPage = (pageTarget: number) => {
  if (prefetchCache.has(pageTarget)) return;
  prefetchCache.add(pageTarget);

  if (pageTarget === 1) {
    import(/* webpackPrefetch: true */ "./NavigationPage/ReservationPage");
  } else if (pageTarget === 3) {
    import(/* webpackPrefetch: true */ "./NavigationPage/RestaurantPage");
  }
};
const RestauScreen:React.FC<RestauScreenProps> = ({idrestaurant,styleMenuLoad=-1,interactMenuLoad=false,MenuLoad=[],listdescLoad=[],listBannerLoad=[],headerDescLoad=[emptyBannerRestau[0],{},'',{}],phoneLoad,addressLoad,addressHintLoad,lastUpdateScheduleLoad}) => {
    const {loadPage,setLoadPage} = useContext(AppContext)
    const [restoMeta, setRestoMeta] = useState<RestoMeta | null>(null);
    const idR         = restoMeta?.id           ?? idrestaurant ?? -1;
    const restoName   = restoMeta?.name         ?? "";
    const noteR       = restoMeta?.note         ?? 0;
    const typeResto   = restoMeta?.type         ?? [];
    const cuisinesResto = restoMeta?.cuisines   ?? [];
    const filtersResto  = restoMeta?.filters    ?? [];
    const devantureResto = restoMeta?.devanture ?? "";
    const visibleCityVar = restoMeta?.visibleCity ?? "";
    const nbrReviewLoad = restoMeta?.nbrReview ?? 0;
    const pricePers   = restoMeta ? Math.round(restoMeta.totalPrice || 0) : 15;
    const navigate = useNavigate();
    const { slugWithId } = useParams();
    const [idUrl, setIdUrl] = useState("");

    const [restaurantJson,setRestaurantJson] = useState({})
    const WHITELIST = ['Crêperie','Pizzeria','Restaurant à Volonté','Guinguette','Restaurant Ouvrier'];
    const [descSeo,setDescSeo] = useState(`Menu, photos, prix, horaires, avis, adresse : toutes les infos de ce restaurant sont sur QuelResto.`)
    const location = useLocation();
    const [canonicalUrl, setCanonicalUrl] = useState<string>(typeof window !== 'undefined'
        ? `${window.location.origin}${location.pathname}`
        : '');

    const [search] = useSearchParams();

    const [isResaLink,setIsResaLink] = useState('')
    const [isResaPhone,setIsResaPhone] = useState(false)

    const [scheduleLoad,setScheduleLoad] = useState(false)
    const [lastUpdateSchedule,setLastUpdateSchedule] = useState<Date>(lastUpdateScheduleLoad || new Date())
    const [schedule,setSchedule] = useState<typeSchedule>(headerDescLoad[1])
    const [special_date,setSpecialDale] = useState<typeSpecialDate>(headerDescLoad[3])
    const [phoneResto,setPhoneResto] = useState(phoneLoad ? phoneLoad : '')
    const [addressResto,setAddressResto] = useState<[string,string]>(addressLoad ? addressLoad : ['',''])
    const [addressHintResto,setAddresHintResto] = useState(addressHintLoad ? addressHintLoad : '')
    const [dailyMenu,setDailyMenu] = useState<typeDailyMenu>({image:'',dates:[]})
    const [menu,setMenu] = useState<Menu>(MenuLoad)
    const [listDesc,setListDesc] = useState< (contentBlockRestau | SpaceBlock)[]>(listdescLoad)
    const [listBannerResto,setListBannerResto] = useState(listBannerLoad ? listBannerLoad : [])
    const [headerDesc,setHeaderDesc] = useState< [contentBannerResto,typeSchedule,string,typeSpecialDate]>(headerDescLoad)
    const [styleMenu,setStyleMenu]= useState<number>(styleMenuLoad)
    const [isInteractive,setIsInteractive] = useState(interactMenuLoad)
    const [dateUpdate,setDateUpdate] = useState<Date>(new Date())
    const [listReview,setListReview] = useState<ReviewProps[]>([])
    const [reviewLoad,setReviewLoad] = useState<boolean>(false)
    const [photoRestaurateur,setPhotoRestaurateur] = useState('')
    const [page, setPage] = useState(2)
    
    useLayoutEffect(() => {
        if (typeof window === "undefined" || window.scrollY <= 5) return;
        window.scrollTo(0, 0);
    }, [page]);

    const [showFilters,setShowFilters] = useState(false)
    useEffect(() => {
        const skipSplash = search.get("src") === "home";
        setLoadPage(skipSplash);
        setTimeout(() => {
            setLoadPage(true)
        },2300)
        const url = new URL(window.location.href);
        if (url.searchParams.has('src')) {
            url.searchParams.delete('src');
            window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
        }
    },[])
   useEffect(() => {
        if (!slugWithId) return;
        const parts = slugWithId.split("_");
        const idCandidate = parts[1]; 
        setIdUrl(idCandidate);
        if (idCandidate) {
            const fetchAction = async () => {
                try {
                    await fetchInfo(idCandidate,!MenuLoad.length)
                } catch (error) {
                    console.error('Erreur de décodage:', error);
                }
            }
            fetchAction();
        }
        
    }, [slugWithId]);
    const fetchInfo = async (idUrl:string,shouldMenu:boolean) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getInfoPageResto`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id_url: idUrl,shouldMenu }),
            });

            const data = await response.json();
            if (data.success && data.infopage) {
                if(!data.infopage.published) {
                    if (!slugWithId) {
                        navigate('/');
                        return;
                    }

                    const parts = slugWithId.split("_");
                    if(parts.length < 2 ) navigate('/');
                    const idCandidate = parts[1]; 
                    const encoded = parts[2]; 
                     try {
                        const jsonString = atob(encoded); 
                        const decodedData = JSON.parse(jsonString);
                        if(decodedData.id_url !== idCandidate) {
                           navigate('/')
                        }
                    } catch (e) {
                        navigate('/');
                        return;
                    }
                    
                } else {
                    const cookieConsent = document.cookie
                        .split("; ")
                        .find(row => row.startsWith("QUELRESTO_COOKIE="));
                    if (cookieConsent) {
                        const cookieValue = decodeURIComponent(cookieConsent.split("=")[1]);
                        const parsed = JSON.parse(cookieValue);
                        const hasAnalyticsConsent = parsed["perform-analytics"];
                        const existingScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');

                        if (hasAnalyticsConsent && existingScript && window.gtag) {
                            window.gtag('config', `G-${process.env.REACT_APP_TAG_ANALYSE}`, {
                                page_path: window.location.pathname
                            });
                        }
                    }
                }
                let totalPrice = data.infopage.total_price
                let nbrReview = data.infopage.nbr_review
                let note = data.infopage.note
                let name = data.infopage.name

                const prixTxt = (typeof totalPrice === 'number')
                ? `prix ≈ ${Math.round(totalPrice).toLocaleString('fr-FR')} €/pers`
                : 'prix';

                const noteTxt = (Number(nbrReview) > 0 && Number(note) > 0)
                ? `, ${Number(nbrReview).toLocaleString('fr-FR')} avis, note ${Number(note).toLocaleString('fr-FR',{minimumFractionDigits:1, maximumFractionDigits:1})}/5`
                : '';
                const nextMeta: RestoMeta = {
                    id: data.infopage.idrestaurant,
                    name,
                    note,
                    type: data.infopage.type || [],
                    cuisines: data.infopage.cuisines || [],
                    filters: data.infopage.filters || [],
                    devanture: data.infopage.devanture,
                    nbrReview,
                    visibleCity: data.infopage.visiblecity || "",
                    totalPrice: Math.round(data.infopage.total_price || 0),
                    googlePlaceId: data.infopage.google_place_id || undefined,
                };
                
                setAddresHintResto(data.infopage.address_hint || '')
                setRestoMeta(nextMeta)
                setListBannerResto(data.infopage.listbanner)
            
                setDescSeo(`Menu, photos, horaires, ${prixTxt}${noteTxt}. Adresse et contact de ${name}.`.replace(',.', '.'))
                setRestaurantJson({
                "@type": "Restaurant",
                "name": name,
                ...(Array.isArray(data.infopage.cuisines) && data.infopage.cuisines.length ? {"servesCuisine": data.infopage.cuisines} : {}),
                "image": data.infopage.devanture,
                "priceRange": totalPrice <= 15 ? "€" : totalPrice <= 30 ? "€€" : totalPrice <= 60 ? "€€€" : "€€€€",
                ...(data.infopage.google_place_id ? {
                        "identifier": {
                        "@type": "PropertyValue",
                        "propertyID": "google_place_id",
                        "value": data.infopage.google_place_id,
                        },
                    } : {}),
                ...(data.infopage.nbr_review > 0 ? {
                    "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": Number(note),       
                    "reviewCount": Number(nbrReview),
                    "bestRating": 5,
                    "worstRating": 1
                    }
                } : {}),
                 ...(Array.isArray(data.infopage.reviews) && data.infopage.reviews.length > 0 ? {
                        "review": data.infopage.reviews.map((rev: any) => ({
                        "@type": "Review",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": Number(rev.note),
                            "bestRating": 5,
                            "worstRating": 1,
                        },
                        ...(rev.title ? { "name": rev.title } : {}),
                        "reviewBody": rev.text,
                        "datePublished": rev.post_date,
                        "author": {
                            "@type": "Organization",
                            "name": "QuelResto"
                        }
                        })),
                    }
                    : {}),
                });
            } 
            if (data.success && data.infomenu && shouldMenu) {

                const cityCanonical = (data.infomenu.address?.[1] || "").trim();
                const slugCity = slugify(cityCanonical);
                const nameForCanonical = (data.infopage?.name || data.infomenu?.name || "").trim();
                const slugName = slugify(nameForCanonical);
                const nextCanonical = `${window.location.origin}/restaurant/${slugCity}/${slugName}_${idUrl}`;
                setRestaurantJson(prev => ({
                    ...prev,
                    "@id": `${nextCanonical}#restaurant`,
                    "mainEntityOfPage": { "@id": `${nextCanonical}#webpage` },
                    "url": nextCanonical,
                    address: {
                        "@type": "PostalAddress",
                        "addressLocality": data.infomenu.address[1],
                        "streetAddress": data.infomenu.address[0],
                        "addressCountry": "FR"
                    },
                    "telephone": data.infomenu.phone,
                }));

                setCanonicalUrl(nextCanonical);
                setMenu(data.infomenu.menu)      
                if(data.infomenu.daily_menu) setDailyMenu(data.infomenu.daily_menu)
                setStyleMenu(data.infomenu.stylemenu)
                setIsInteractive(data.infomenu.interactmenu)
                setAddressResto(data.infomenu.address)
                setPhoneResto(data.infomenu.phone)
                setDateUpdate(data.infomenu.date_update) 
            } 
        } catch (error) {
            console.error("Erreur lors de la connexion :", error);
        }
    }

    const touchStartRef = React.useRef<{x: number; y: number} | null>(null);
    
    const handleSwipeStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const t = e.changedTouches[0];
        touchStartRef.current = { x: t.clientX, y: t.clientY };
    };
    
    const handleSwipeEnd = (e: React.TouchEvent<HTMLDivElement>) => {
        const start = touchStartRef.current;
        if (!start) return;
    
        const t = e.changedTouches[0];
        const deltaX = t.clientX - start.x;
        const deltaY = t.clientY - start.y;

        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 60) {
            setPage(prev => (deltaX > 0 ? (prev === 3 ? 1 : prev + 1) : (prev === 1 ? 3 : prev - 1)));
        }

        touchStartRef.current = null;
    };

    const breadcrumbLd = useMemo(() => {
        const city = addressResto?.[1] || ''; 
        const items = [
            { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://www.quelresto.fr/" }
        ];
        if (city) {
            items.push({
            "@type": "ListItem",
            "position": items.length + 1,
            "name": `Restaurants ${cityWithPreposition(city)}`,
            "item": `${window.location.origin}/${slugify(city)}`
            });
        }
        if (restoName) {
            items.push({
            "@type": "ListItem",
            "position": items.length + 1,
            "name": restoName, 
            "item": canonicalUrl
            });
        }
        if (items.length < 2) return null;
        return {
            "@type": "BreadcrumbList",
            "@id": `${canonicalUrl}#breadcrumb`,
            "itemListElement": items
        };
    }, [addressResto?.[1], restoName, canonicalUrl]);


    const webPageLd = useMemo(() => {
        if (!(!!(restoName && addressResto?.[1]))) return null;
        return {
            "@type": "WebPage",
            "@id": `${canonicalUrl}#webpage`,
            "url": canonicalUrl,
            "name": `${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`,
            "description": `Menu, photos, horaires et prix de ${restoName}.`,
            "inLanguage": "fr-FR",
            "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
            "about": { "@id": `${canonicalUrl}#restaurant` },
            "breadcrumb": { "@id": `${canonicalUrl}#breadcrumb` }
        };
    }, [restoName, addressResto]);
    const memoJsonLd = useMemo(() => JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [restaurantJson, webPageLd, breadcrumbLd]
    }), [restaurantJson,webPageLd,breadcrumbLd]);


    const [footerFilters,setFooterFilters] = useState<string[]>([])
    const seoPriorityFilters =  ["Terrasse extérieure","Vue exceptionnelle","Chèque-vacances","Végétarien","Végan","Halal","Parking gratuit","Accès PMR","En couple","En famille avec enfants","Bord de l’eau","Privatisable","Sans gluten","Terrasse couverte","Entre amis",];

    useEffect(() => {
        function getFooterFilters(restoFilters: string[]): string[] {
            const final: string[] = [];
            for (const f of seoPriorityFilters) {
                if (restoFilters.includes(f)) {
                final.push(f);
                if (final.length >= 7) return final;
                }
            }
            for (const f of restoFilters) {
                if (!final.includes(f)) {
                final.push(f);
                if (final.length >= 7) return final;
                }
            }
            return final;
        }
        if(filtersResto && filtersResto.length && filtersResto.length > 0 ) setFooterFilters(getFooterFilters(filtersResto))
    },[filtersResto])

    const showCities:string = useMemo(()=> { return (visibleCityVar && visibleCityVar !== addressResto[1]) ? ` ${cityWithPreposition(visibleCityVar)} (${addressResto[1]})` : cityWithPreposition(addressResto[1])},[addressResto,visibleCityVar])
    const FEMININE_TYPES = ["brasserie","crêperie","pizzeria","auberge-restaurant","guinguette",];
    const isMasculin = (type:any) => {
        if(type && typeof type === 'string' && type !== '') {
            if(FEMININE_TYPES.includes(type.toLocaleLowerCase())) return false
            else return true
        } else return true
    }
    return (
        <>
        {restoName && 

         <Helmet>
            <title>{`${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`}</title>
            <meta
            name="description"
            content={descSeo}
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content={devantureResto} />

            <meta property="og:title" content={`${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`} />
            <meta property="og:description" content={descSeo} />
            <meta property="og:image" content={devantureResto} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonicalUrl} />
            <link rel="canonical" href={canonicalUrl} />
            <script type="application/ld+json">{memoJsonLd}</script>
        </Helmet> }
        

        <div className="restauScreen primaryBack" id="restauScreen">
            {!loadPage && <div className='loadPage'>
                <img  src={logoWhiteHight} loading="lazy" alt="logo"/>
                <div className="mask"></div>
            </div>}
            <div className="mainCorp" style={{zIndex:1}} > 
                <TopBar name={restoName} page={page} setPage={setPage} />
                
                {page === 2 ? <div className="menuShell">
                    {styleMenu === -1 && <div className="menuNotLoad pageMenu primaryBack"><Loading /></div> }
                    <MenuPage photoRestaurateur={photoRestaurateur} setPhotoRestaurateur={setPhotoRestaurateur} nbrReviewLoad={nbrReviewLoad} setReviewLoad={setReviewLoad} reviewLoad={reviewLoad} listReview={listReview}  setListReview={setListReview} Menu={menu} dateUpdate={dateUpdate}  StyleMenu={styleMenu} isInteractMenu={isInteractive} idRestaurant={idR} note={noteR} dailyMenu={dailyMenu}/>
                </div>
                : <React.Suspense fallback={<div className="menuNotLoad"><Loading /></div>}>
                    {     
                        page === 1 ?
                        <ReservationPage address_hint={addressHintResto} lastUpdateSchedule={lastUpdateSchedule} id_url={idUrl} nameResto={restoName} scheduleLoad={scheduleLoad} setScheduleLoad={setScheduleLoad}  schedule={schedule} special_date={special_date} setLastUpdateSchedule={setLastUpdateSchedule} setSchedule={setSchedule} setSpecialDate={setSpecialDale} phone={phoneResto} address={addressResto} idrestaurant={idR} 
                            isResaLink={isResaLink} isResaPhone={isResaPhone} setIsResaLink={setIsResaLink} setIsResaPhone={setIsResaPhone}/>
                        :  <RestaurantPage address_hint={addressHintResto} isResaPhone={isResaPhone} setIsResaPhone={setIsResaPhone} lastUpdateSchedule={lastUpdateSchedule} id_url={idUrl} nameResto={restoName} setHeaderDesc={setHeaderDesc} setLastUpdateSchedule={setLastUpdateSchedule} setListBanner={setListBannerResto} setListDesc={setListDesc} headerDesc={headerDesc} listBanner={listBannerResto} type={typeResto} cuisines={cuisinesResto} listFilters={filtersResto} description={listDesc} idResto={idR} phone={phoneResto} address={addressResto} />
                    }
                </React.Suspense>
                }
                {showFilters && <React.Suspense fallback={null}>
                    <ContainerFiltersResto type={typeResto} cuisines={cuisinesResto} listFilters={filtersResto} setShowFilters={setShowFilters}/> </React.Suspense>}
                <div className="secondaryBack largeText infoBottom"> 
                    <div className="separationInfo"></div>
                    <h2 className="titleDesc secondaryBack largeTitle" style={{marginBottom: '10px'}}>{typeResto && typeResto[0]} {showCities} – menu, carte, photos, avis, horaires et prix.</h2>
                    <h3 className="titleScndDesc secondaryBack largeTitle text">{restoName} - QuelResto</h3>
                    <p className="text XsmallText">{restoName} est {isMasculin(typeResto[0] || '') ? ' un ' : ' une '} {(typeResto && typeResto[0]) ? `${typeResto[0].toLowerCase()} ` : ' restaurant '} {showCities}. {isMasculin(typeResto[0] || '') ? ' Il ' : ' Elle '} propose une cuisine {cuisinesResto && cuisinesResto.length > 0 && cuisinesResto[0] ? `${cuisinesResto[0].toLowerCase()}${cuisinesResto.length > 1 && cuisinesResto[1] ? ` et ${cuisinesResto[1].toLowerCase()}, ` : ', '}`  : ''} avec un prix moyen de {pricePers}&nbsp;€ par personne.</p>
                    {(footerFilters && footerFilters.length) ? <div className="text XsmallText listFilters">
                        <span className="nameListFilters">Voici quelques filtres renseignés par le restaurant :&nbsp;</span>
                        {footerFilters.map((elem,id) => {
                            return <React.Fragment key={'elemFiltersFooter'+id}><span className="elemFilter" style={{fontStyle:'italic'}}>{elem}</span>
                                {id < footerFilters.length-1 ? `,\u00A0` : ''}
                                {id === footerFilters.length-1 ? '.' : ''}
                            </React.Fragment>
                        })}
                        <span className="moreFilters pointer" onClick={() => setShowFilters(true)}>Voir tous les filtres du restaurant</span>
                    </div> : <></>}
                    <p className="text XsmallText">Les horaires et la carte sont régulièrement actualisés, avec leur date de mise à jour affichée. Les avis clients indiquent toujours la date de publication, pour vous garantir des informations fiables et récentes.</p>
                    <p className="text XsmallText discover">Découvrez aussi &nbsp;<a href={`${window.location.origin}/${slugify(addressResto[1])}`} target="_blank">Les meilleurs restaurants {cityWithPreposition(addressResto[1])}</a>&nbsp; pour explorer d’autres adresses à proximité !</p>
                </div>
                <Footer isResto={true}/>
                <div className="espacmentPhone"></div>
                <div
                    className="menuTel primaryBack"
                    onTouchStart={handleSwipeStart}
                    onTouchEnd={handleSwipeEnd}
                >
                    
                    <div className="containerPart"><h2 className={`pointer part ${page === 3 ? 'smallTitleBold' : 'smallTitle'}`} onTouchStart={() => prefetchPage(3)} onClick={() => setPage(3)}>
                        Restaurant
                        {page === 3 && <div></div>}
                    </h2></div>
                    <div className="containerPart"><h2 className={`pointer part ${page === 2 ? 'smallTitleBold' : 'smallTitle'}`} onClick={() => setPage(2)}>
                        Menu
                        {page === 2 && <div></div>}
                    </h2></div>
                    <div className="containerPart"><h2 className={`pointer part ${page === 1 ? 'smallTitleBold' : 'smallTitle'}`} onTouchStart={() => prefetchPage(1)} onClick={() => setPage(1)}>
                        Réservation
                        {page === 1 && <div></div>}
                    </h2></div>
                </div>

 
            </div>
        </div>
        </>
    )
}

export default RestauScreen
